var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "vuDropdownItem",
      class: _vm.classes,
      attrs: { id: _vm.p.id },
    },
    [
      _vm.p.type === "default"
        ? _c(
            _vm.p.linkComponent,
            _vm._b(
              {
                ref: "focusPoint",
                tag: "component",
                on: { click: _vm.onClick },
                nativeOn: {
                  keydown: function ($event) {
                    return _vm.onKeyDown.apply(null, arguments)
                  },
                  keyup: function ($event) {
                    $event.preventDefault()
                    return _vm.onKeyUp.apply(null, arguments)
                  },
                  focus: function ($event) {
                    return _vm.p.api.focusItem(_vm.p.id)
                  },
                  blur: function ($event) {
                    return _vm.p.api.blurItem(_vm.p.id)
                  },
                },
              },
              "component",
              Object.assign(
                {},
                {
                  type: _vm.p.link === "" ? "js" : "auto",
                  link: _vm.p.link,
                  tabindex: _vm.p.disabled ? "-1" : null,
                  "aria-disabled": _vm.p.disabled ? "true" : null,
                  role: _vm.p.api.isListBox ? "option" : "presentation",
                },
                _vm.linkComponentProps,
                _vm.p.linkComponentProps
              ),
              false
            ),
            [_vm._t("default")],
            2
          )
        : _vm.p.type === "line"
        ? _c("hr", {
            attrs: { role: "separator", "aria-orientation": "horizontal" },
          })
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }